export type TerminTeilnehmer = { address: string; name?: string };

/** Normalisiert die fachliche Adressauswahl und nutzt den Mail-Absender als Fallback. */
export function terminTeilnehmer(
    adressen: readonly string[],
    fallback: string | null | undefined,
): TerminTeilnehmer[] {
    const kontaktAdressen = adressen
        .map((adresse) => adresse.trim().toLowerCase())
        .filter(Boolean);
    const normalisiert =
        kontaktAdressen.length > 0
            ? kontaktAdressen
            : fallback?.trim()
              ? [fallback.trim().toLowerCase()]
              : [];
    return Array.from(new Set(normalisiert)).map((address) => ({ address }));
}
